<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <div
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.url"
        :data-path="tag.fullPath"
        :class="[isActive(tag) ? 'active speActive' : '']"
        class="tags-view-item"
        @click="jump(tag)"
        @contextmenu.prevent="openMenu(tag, $event)"
      >
        <span @click="clickTag">{{ tag.title }}</span>
        <span v-if="!isAffix(tag) && visitedViews.length !== 1" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
        <span v-else style="opacity: 0; width: 0.1px" class="el-icon-close" />
      </div>
    </scroll-pane>
    <div class="notify-msg">
      <msgNotify></msgNotify>
    </div>
    <div class="import-export-module">
      <importExportModule></importExportModule>
    </div>
  </div>
</template>

<script>
import ScrollPane from "./ScrollPane"
import path from "path"
import { mapState } from "vuex"
import { microAppForceSetGlobalData } from "@/micro/micro-app-utils"
import msgNotify from "@/layout/components/msgNotify/index.vue"
import importExportModule from "@/layout/components/ImportExportModule/index.vue"
export default {
  components: { ScrollPane, msgNotify, importExportModule },

  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      goBeatClickNum: 0,
      canClick: true,
      timer: null
    }
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return [this.$store.state.user.routes]
    },
    whatEnv() {
      if (this.$route.fullPath.indexOf("count/") > -1) {
        return localStorage.getItem("env")
      } else {
        return ""
      }
    }
  },
  watch: {
    $route() {
      this.moveToCurrentTag()
      this.goBeatClickNum = 0
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu)
      } else {
        document.body.removeEventListener("click", this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    const t = this
    // 全局关闭当前页面方法
    window.$closeAllTagsBaseApp = function (path) {
      const newFullPath = "/" + path.split("/")[1] + "#" + path
      t.visitedViews.forEach(item => {
        if (item.path === path || item.fullPath === newFullPath || item.fullPath.indexOf(decodeURIComponent(newFullPath)) > -1) {
          t.closeSelectedTag(item)
        }
      })
    }
  },
  methods: {
    /**
     * 添加beta环境判断前缀
     * 因无法布置beta服务，交由前端来进行beta环境前缀设置
     * 该方法仅在数据中心api中生效
     */
    clickTag() {
      const canClickPerson = ["御风", "太阳", "桀诺", "本堂", "戴沐白", "马修诺", "秦明", "乾轩", "泰隆", "钴蓝", "凯亚", "吉田"]
      if (canClickPerson.indexOf(this.userInfo.userName) < 0) {
        return
      }
      // 如果beat环境已开启，则点击计数无效
      if (localStorage.getItem("env") && localStorage.getItem("env") === "beta") {
        return
      }
      // 开始计数，3次进入beat环境
      this.goBeatClickNum++
      if (this.goBeatClickNum === 3) {
        // 设置beat环境开启
        localStorage.setItem("env", "beta")
        // 刷新页面，重新获取api前缀
        location.reload()
      }
    },
    jump(route) {
      // 防止快速点击问题
      if (!this.$store.state.tagsView.canGetSonAppInfo) {
        return
      }
      if (location.pathname + location.hash === route.fullPath) {
        return
      }
      // 设置，不接收接收子应用的router消息间隔，防止来回跳页面
      this.$store.dispatch("tagsView/updateCanGetSonAppInfo", false)
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.$store.dispatch("tagsView/updateCanGetSonAppInfo", true)
      }, 500)
      // this.canClick = false
      this.$store.dispatch("tagsView/addView", route)
      // 标签跳转状态更新
      this.$store.dispatch("tagsView/changeNowClickActionType", "change")
      this.$router.push({ path: route.fullPath })
    },
    isActive(route) {
      return route.fullPath.split("?")[0] === this.$route.fullPath.split("?")[0]
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = "/") {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes))
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch("tagsView/addVisitedView", tag)
        }
      }
    },
    moveToCurrentTag() {
      this.$nextTick(() => {
        const tags = this.$refs.tag
        if (!tags) {
          return
        }
        for (const tag of tags) {
          if (tag.dataset.path === this.$route.fullPath) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.dataset.path !== this.$route.fullPath) {
              this.$store.dispatch("tagsView/updateVisitedView", this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch("tagsView/delCachedView", view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: "/redirect" + fullPath
          })
        })
      })
    },
    getBelong(route) {
      route = JSON.parse(JSON.stringify(route))
      route.url = route.path || route.url
      if (!route.url) {
        route.url = route.fullPath.split("#")[1]
      }
      return route.url.split("/")[1]
    },
    closeSelectedTag(view) {
      const newView = Object.assign({}, view)
      newView.fullPath = newView.url || newView.fullPath
      newView.path = newView.url
      // 当没有pathName时，需要赋值，子应用才能做清除缓存操作
      if (!newView.pathName) {
        newView.pathName = newView.name
      }
      // 解决跨中心，关闭后缓存的问题(目前只针对数据中心（show.hide）与其他跨应用之间不缓存的问题,关闭标签的时候，判断下一个页面是否是同中心，如果不是，则添加刷新needRefresh标识，给子应用处理)
      if (this.visitedViews.length > 1) {
        let upVisited = this.visitedViews[this.visitedViews.length - 2]
        if (!upVisited) {
          upVisited = this.visitedViews[this.visitedViews.length - 1]
        }
        const upVisitedBelong = this.getBelong(upVisited)
        const nowVisitedBelong = this.getBelong(newView)
        if (upVisitedBelong !== nowVisitedBelong) {
          newView.needRefresh = true
        }
      }
      // 当前页面关闭
      if (view.fullPath === this.$route.fullPath) {
        microAppForceSetGlobalData({ type: "store", data: { fnType: "dispatch", nameSpace: "tagsView/delView", fnData: newView } })
      } else {
        // 非当前页面关闭（同中心没问题，以及用show做显隐的数据中心也没问题）
        microAppForceSetGlobalData({ type: "store", data: { fnType: "dispatch", nameSpace: "tagsView/delView", fnData: newView } })
        // 非当前页面关闭(结合微应用 aftershow进行操作，非激活子应用对于缓存的关闭管理)
        // 非激活子应用，无法进行子应用的store操作，所以存数组，切换路由在beforeshow中用
        // 数据中心，不进这套规则
        if (newView.sysBelong !== "/count") {
          this.$store.dispatch("tagsView/addHideCloseTags", newView)
        }
        // 重新获取tags需不需要滚动，显示左右宽度
        this.$refs.scrollPane.restGetWidth()
      }
      this.$store.dispatch("tagsView/delView", view).then(({ visitedViews }) => {
        const backToOriginPagePath = this.getParameterFromURL("backToOriginPagePath", view.fullPath)
        // 如果存在backToOriginPagePath参数，则优先跳转这个页面
        if (backToOriginPagePath) {
          // 如果from的页面，包含？参数需要处理，否则backToOriginPagePath无法匹配上，从而导致空白问题
          const findItem = this.visitedViews.filter(item => item.fullPath.replaceAll("#", "").split("?")[0] == backToOriginPagePath)
          // 如果找到，则直接跳转
          if (findItem.length > 0) {
            this.$router.push({ path: findItem[0].fullPath })
          } else {
            const backToOriginPagePathArr = backToOriginPagePath.split("/").filter(Boolean)
            let url = ""
            backToOriginPagePathArr.forEach((item, index) => {
              if (index === 0) {
                url = url + "/" + item + "#"
              } else {
                url = url + "/" + item
              }
            })
            this.$router.push({ path: url })
          }
        }
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        } else {
          setTimeout(() => {
            document.querySelector(".speActive").click()
          }, 30)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch("tagsView/delOthersViews", this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch("tagsView/delAllViews").then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        // this.$router.push(latestView.fullPath)
        const leftNav = this.routes[0].filter(item => item.url === latestView.sysBelong)?.[0]
        if (leftNav) {
          setTimeout(() => {
            this.$store.dispatch("app/saveNowRouteInfo", leftNav)
          }, 500)
        }

        // 新增Meta属性tagsFrom，判断关闭后，跳回来源页面(有问题)
        // if (view.meta.tagsFrom) {
        //   this.$router.push({ name: view.meta.tagsFrom })
        // } else {
        //   this.$router.push(latestView.fullPath)
        // }
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "Dashboard") {
          // to reload home page
          this.$router.replace({ path: "/redirect" + view.fullPath })
        } else {
          this.$router.push("/")
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    },

    getParameterFromURL(parameterName, url) {
      if (!url) {
        url = window.location.href
      }
      parameterName = parameterName.replace(/[\[\]]/g, "\\$&")
      var regex = new RegExp("[?&]" + parameterName + "(=([^&#]*)|&|#|$)")
      var results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ""
      return decodeURIComponent(results[2].replace(/\+/g, " "))
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 40px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;

  .tags-view-wrapper {
    flex-shrink: 0;

    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      border: 1px solid #e7e9ec;
      border-radius: 12px;
      color: #999999;
      background: #fff;
      padding: 3px 6px;
      font-size: 13px;
      margin-right: 12px;

      /*&:first-of-type {*/
      /*  margin-left: 12px;*/
      /*}*/
      /*&:last-of-type {*/
      /*  margin-right: 15px;*/
      /*}*/
      &.active {
        color: #fff;
        background: #3296fa;
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .el-scrollbar__wrap {
    display: flex;
    align-items: center;
    //margin-top: 5px;
    margin-bottom: -10px !important;
  }

  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;

      &:before {
        /*transform: scale(0.6);*/
        display: inline-block;
        vertical-align: -3px;
      }

      &:hover {
        //background-color: #b4bccc;
        //color: #fff;
      }
    }
  }
}

.hide {
  display: none !important;
}

.notify-msg {
  position: absolute;
  top: 12px;
  right: 20px;
}

.import-export-module {
  position: absolute;
  top: 12px;
  right: 55px;
}
</style>
